const steps = [
  {
    icon: "ri-radar-line",
    title: "搜集线索",
    desc: "抓取公开报道、当事人账号与现场素材，先建立完整的素材池，避免只看到截断片段。",
  },
  {
    icon: "ri-links-line",
    title: "交叉验证",
    desc: "对关键事实至少比对两个独立信源，标注无法核实的内容，并写明信息来源。",
  },
  {
    icon: "ri-node-tree",
    title: "梳理时间线",
    desc: "把事件拆成可排序的节点：谁在什么时候说了什么，让因果顺序替代情绪排序。",
  },
  {
    icon: "ri-scales-3-line",
    title: "呈现多方视角",
    desc: "并列各方立场与依据，把事实、说法和推测分开呈现，交给你自己判断。",
  },
];

export default function TimelineShowcase() {
  return (
    <section id="method" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-10 px-4 py-12 md:px-8 md:py-16 lg:grid-cols-2 lg:gap-14">
        <div className="order-2 lg:order-1">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">
            我们的工作方式
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            一条时间线，是怎么被梳理出来的
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            热点之所以让人看不懂，大多不是因为信息太少，而是因为信息碎、更新快、立场杂。
            我们固定用四步，把混乱的讨论还原成可追读的顺序。
          </p>

          <ol className="mt-8 space-y-6">
            {steps.map((step, index) => (
              <li key={step.title} className="flex gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${step.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                    <span className="text-xs font-semibold text-foreground-400">
                      0{index + 1}
                    </span>
                    {step.title}
                  </h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>

        <div className="order-1 lg:order-2">
          <div className="h-64 w-full overflow-hidden rounded-lg border border-background-200 bg-background-200 md:h-96 lg:h-full lg:min-h-[420px]">
            <img
              src="https://readdy.ai/api/search-image?query=editorial%20flat%20lay%20of%20a%20paper%20timeline%20with%20pinned%20notes%20and%20a%20magnifying%20glass%20on%20a%20warm%20cream%20desk%2C%20soft%20daylight%2C%20magazine%20still%20life%2C%20high%20detail&width=1000&height=750&seq=hei-method-desk&orientation=landscape"
              alt="纸面时间线与放大镜组成的复盘工作台"
              title="热点事件时间线复盘方法"
              className="h-full w-full object-top object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}